import(/* webpackMode: "eager" */ "/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/contacts-1.png");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/contacts-2.png");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/contacts-3.png");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/contacts-4.png");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/ig.svg");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/tg.svg");
;
import(/* webpackMode: "eager" */ "/frontend/public/images/vk.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/EventPreviewContainer/EventPreviewContainer.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/EventPreviewSection/EventPreviewSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/PartnerList/PartnerList.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/PartnerSection/PartnerSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/PopupModal/PopupModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/ReviewList/ReviewList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/ScheduleList/ScheduleList.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/ScheduleSection/ScheduleSection.module.scss");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/ReviewSection/ReviewSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/SliderList/SliderList.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/SliderSection/SliderSection.module.scss");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/ReviewText/ReviewText.module.scss");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/ReviewContent/ReviewContent.module.scss");
;
import(/* webpackMode: "eager" */ "/frontend/src/components/ContactsSection/ContactsSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/TheaterSection/TheaterSection.tsx");
;
import(/* webpackMode: "eager" */ "/frontend/src/loaders/image-loader.js");
;
import(/* webpackMode: "eager" */ "/frontend/src/styles/page.scss");
